<div class="main-page cadastros">
  <div class="container-fluid">
    <app-title>{{ title ? title : 'Inserir novo' }} </app-title>

    <div class="row mt-3 no-gutters p-4 row-form">
      <div class="col-12">
        <form [formGroup]="eletronicFenceForm" (ngSubmit)="submitForm()">
          <h2 class="mb-3">Empresas e divisões</h2>
          <div class="form-row">
            <div class="form-group col-md-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Empresa registrada pela cerca</mat-label>
                <mat-select
                  [value]="empresaRegistrada"
                  [compareWith]="compareCompanies"
                  (selectionChange)="onEmpresaRegistradaChange($event)"
                  required>
                  <mat-option *ngFor="let type of company" [value]="type">
                    {{ type.nome }} ({{ orgKind(type) }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group col-md-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Empresas auxiliares para vincular</mat-label>
                <mat-select
                  [value]="empresasAuxiliares"
                  [compareWith]="compareCompanies"
                  (selectionChange)="onAuxiliaresChange($event)"
                  multiple>
                  <mat-option *ngFor="let type of empresasAuxiliaresDisponiveis" [value]="type">
                    {{ type.nome }} ({{ orgKind(type) }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <h2 class="mb-3">Dados Cadastrais </h2>
          <div class="form-row">
            <div class="form-group col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>Nome</mat-label>
                <input formControlName="nmNome" matInput placeholder="Nome" maxlength="80"
                  minlength="1" required />
              </mat-form-field>
              <validation-errors [form]="eletronicFenceForm" controlLabel="Nome" controlName="nmNome">
              </validation-errors>
            </div>
         
            <div class="form-group col-lg-2">
              <mat-form-field appearance="outline">
                <mat-label>Velocidade Alerta Sonoro</mat-label>
                <input type="number" formControlName="nrVelocidadeAlarmeVeiculo" matInput placeholder="Limite de Velocidade para o Veículo" minlength="1" required />
              </mat-form-field>
              <validation-errors [form]="eletronicFenceForm" controlLabel="Limite de Velocidade para o Veículo" controlName="nrVelocidadeAlarmeVeiculo">
              </validation-errors>
            </div>
         
            <div class="form-group col-lg-2">
              <mat-form-field appearance="outline">
                <mat-label>Velocidade Evento Plataforma</mat-label>
                <input type="number" formControlName="nrVelocidadeAlarmePainel" matInput placeholder="Limite de Velocidade para o Painel" minlength="1" required />
              </mat-form-field>
              <validation-errors [form]="eletronicFenceForm" controlLabel="Limite de Velocidade para o Painel" controlName="nrVelocidadeAlarmePainel">
              </validation-errors>
            </div>

          </div>          
          <div *ngIf="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <div class="form-group mt-2 mb-0 text-center">
            <back-button></back-button>
            <button type="submit" class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
              Salvar
            </button>
          </div>
        </form>

        <h2 class="mb-3">Selecionar veículos </h2>
          <div class="form-row">
            <br/>
            <section class="example-section">
              <div class="form-group">
                <input type="text" class="form-control" (keyup)="handleFilter($event.target.value)" placeholder="pesquisar..."
                  autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search />
              </div>  
            <div class="box-placas">
              <span class="example-list-section">
                <mat-checkbox class="example-margin"
                              [checked]="allComplete"
                              [indeterminate]="someComplete()"
                              (change)="setAll($event.checked)">
                  {{task.name}}
                </mat-checkbox>
              </span>
              <span class="example-list-section">
                <ul>
                  <li *ngFor="let subtask of task.subtasks">
                    <mat-checkbox [(ngModel)]="subtask.completed"
                                  [color]="subtask.color"
                                  (ngModelChange)="onTerminalToggle(subtask)">
                      {{subtask.name}} 
                    </mat-checkbox>
                  </li>
                </ul>
              </span>
            </div>
            </section>
          </div> 
      </div>
    </div>
  </div>
</div>
